import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home'
import ConsultingCenter from '@/views/consultingCenter'
import AboutUs from '@/views/aboutUs'
import ContactUs from '@/views/contactUs'
import AddUs from '@/views/addUs'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'root',
      component: Home,
      redirect:'/home'
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/consultingCenter',
      name: 'consultingCenter',
      component: ConsultingCenter
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: AboutUs
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: ContactUs
    },
    {
      path: '/addUs',
      name: 'addUs',
      component: AddUs
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js